import { EmptyState } from './ui';

const SubscriptionsEmptyState = ({ total, visible }: { total: number; visible: number }) => {
  if (total === 0) return <EmptyState text="Nenhuma assinatura no tópico." />;
  if (visible === 0) return <EmptyState text="Nenhum consumidor encontrado para a busca." />;
  return null;
};

export default SubscriptionsEmptyState;
